import { getApp } from "firebase/app";
import { Analytics, getAnalytics } from "firebase/analytics";

const useAnalytics = (): Analytics => {
    const app = getApp();
    return getAnalytics(app);
};

export default useAnalytics;
